import { put, call } from 'redux-saga/effects';
import {
  addNewCustomerRequest,
  getCustomerList,
  updateCustomerRequest,
  deleteCustomerRequest,
  getSelectedCustomerRequest
} from '../service/customerService';
import * as actions from '../../store/action/customerAction';
import common, { genarateVehicleAddObject, refeshTokenset } from '../common';
// import { saveLoginUser } from '../../store/action/authAction';
import { sendAddNewVehicleRequest } from '../../store/action/vehicleAction';


export function* sendAddNewCustomerRequest(data){
  yield put(actions.loadCustomerListError(null))
  try{
    const response = yield call(addNewCustomerRequest,data.payload.customer);
    if(response && response.data && response.data.statusCode && response.data.statusCode === 201 ){
      const customerData = {
        firstName: data.payload.customer.FirstName,
        lastName: data.payload.customer.LastName,
        email: data.payload.customer.EmailAddress,
        phone: data.payload.customer.MobilePhone,
        notes: data.payload.notes || ''
      }
      const payload = genarateVehicleAddObject(data.payload.vehicle, response.data.result.id)
      yield put(sendAddNewVehicleRequest({ ...payload, _customerData: customerData }))
    }
    // else if(response && response.data && response.data.statusCode && response.data.statusCode === 403 ){
    //   yield put(saveLoginUser(false))
    //   invalidToken()
    // }
    else {
      const massage = response.data.message
      yield put(actions.loadCustomerListError(massage))
    }
    if(response && response.data && response.data.result && response.data.result.newAccessToken){
      refeshTokenset(response.data.result.newAccessToken)
    }
  }catch(error){
    const massage = !error.response ? common.connectionError : common.error
    yield put(actions.loadCustomerListError(massage))
  }
}

export function* loadCustomerListRequest(data){
  yield put(actions.loadCustomerListError(null))
  try{
    yield put(actions.loadCustomerListLoading(true));
    const response = yield call(getCustomerList,data.payload);
    if(response && response.data && response.data.statusCode && response.data.statusCode === 200 ){
      const customerList = response.data.result.result
      yield put(actions.loadCustomerListSuccess(customerList))
    }
    // else if(response && response.data && response.data.statusCode && response.data.statusCode === 403 ){
    //   yield put(saveLoginUser(false))
    //   invalidToken()
    // }  
    else{
      yield put(actions.loadCustomerListLoading(false));
      const massage = common.error
      yield put(actions.loadCustomerListError(massage))
    }
    if(response && response.data && response.data.result && response.data.result.newAccessToken){
      refeshTokenset(response.data.result.newAccessToken)
    }
    yield put(actions.loadCustomerListLoading(false));
  }catch(error){
    yield put(actions.loadCustomerListLoading(false));
    const massage = !error.response ? common.connectionError : common.error
    yield put(actions.loadCustomerListError(massage))
  }
}

export function* sendUpdateCustomerRequest(data){
  yield put(actions.loadCustomerListError(null))
  try{
    const response = yield call(updateCustomerRequest,data.payload.customer);
    if(response && response.data && response.data.statusCode && response.data.statusCode === 200 ){
      const customerData = {
        firstName: data.payload.customer.FirstName,
        lastName: data.payload.customer.LastName,
        email: data.payload.customer.EmailAddress,
        phone: data.payload.customer.MobilePhone,
        notes: data.payload.notes || ''
      }
      const payload = genarateVehicleAddObject(data.payload.vehicle, response.data.result.id)
      yield put(sendAddNewVehicleRequest({ ...payload, _customerData: customerData }))
    }
    // else if(response && response.data && response.data.statusCode && response.data.statusCode === 403 ){
    //   yield put(saveLoginUser(false))
    //   invalidToken()
    // }
    else{
      const massage = response.data.message
      yield put(actions.loadCustomerListError(massage))
    }
    if(response && response.data && response.data.result && response.data.result.newAccessToken){
      refeshTokenset(response.data.result.newAccessToken)
    }
  }catch(error){
    const massage = !error.response ? common.connectionError : common.error
    yield put(actions.loadCustomerListError(massage))
  }
}

export function* sendDeleteCustomerRequest(data){
  yield put(actions.loadCustomerListError(null))
  try{
    yield put(actions.loadCustomerListLoading(true));
    const response = yield call(deleteCustomerRequest,data.payload);
    if(response && response.status && response.status === 200 && response.data &&  response.data.statusCode &&  response.data.statusCode === 404 && response.data.result.code ){
      var massage = common.massages.customerDeleteMassage
      const errorCode = common.deleteMassages.find(element => element.id === response.data.result.code)
      if(errorCode){
        massage = errorCode.description
      }
      yield put(actions.loadCustomerListError(massage)) 
    } 
    else if(response && response.status && response.status === 200 && response.data &&  response.data.statusCode &&  response.data.statusCode === 200 ){
      const massage = response.data.message
      yield put(actions.sendCustomerSuccess(massage)) 
    } 
    // else if(response && response.data && response.data.statusCode && response.data.statusCode === 403 ){
    //   yield put(saveLoginUser(false))
    //   invalidToken()
    // } 
    else{
      const massage = response.data.message
      yield put(actions.loadCustomerListError(massage))
    }
    if(response && response.data && response.data.result && response.data.result.newAccessToken){
      refeshTokenset(response.data.result.newAccessToken)
    }
    yield put(actions.loadCustomerListLoading(false));
  }catch(error){
    yield put(actions.loadCustomerListLoading(false));
    const massage = common.error
    yield put(actions.loadCustomerListError(massage))
  }
}

export function* loadSelectedCustomerRequest(data){
  yield put(actions.loadCustomerListError(null))
  try{
    yield put(actions.loadCustomerListLoading(true));
    const response = yield call(getSelectedCustomerRequest,data.payload);
    if(response && response.data && response.status === 200 ){
      const customer =  response.data
      yield put(actions.loadSelectedCustomerSuccess(customer))
    } 
    // else if(response && response.data && response.data.statusCode && response.data.statusCode === 403 ){
    //   yield put(saveLoginUser(false))
    //   invalidToken()
    // }  
    else {
      yield put(actions.loadCustomerListLoading(false));
      const massage = common.error
      yield put(actions.loadCustomerListError(massage))
    }
    if(response && response.data && response.data.newAccessToken){
      refeshTokenset(response.data.newAccessToken)
    }
    yield put(actions.loadCustomerListLoading(false));
  }catch(error){
    yield put(actions.loadCustomerListLoading(false));
    const massage = common.error
    yield put(actions.loadCustomerListError(massage))
  }
}
